import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import ProposalAllDetailWidget from '../../../widgets/adminReport/ProposalAllDetail/ProposalAllDetailWidget'
import { getProjectAllDetail } from '../../../redux/actions/adminReport'

export default function ProposalAllDetail() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()

    try {
      const _schema = await getProjectAllDetail()
      // console.log('schema ', _schema)
      setSchema(_schema)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }

    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isSearch>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isSearch>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal isSearch>
      <ContentHeader header={schema.header} subHeader={schema.subHeader} />

      <ProposalAllDetailWidget schema={schema.form} />

      <br />
    </SidebarProposal>
  )
}

// const mockSchema = {
//   header: 'โครงการทั้งหมด',
//   subHeader: '',
//   form: {
//     searchObject: {
//       header: 'ค้นหาข้อมูล',
//       reportName: 'โครงการทั้งหมด',
//       buttonText: {
//         disabled: true,
//         // errorMessage: 'ดาวน์โหลดเอกสารไม่สำเร็จ',
//         // downloadButtonName: 'Export Excell',
//         searchButtonName: 'ค้นหา',
//         cancelButtonName: 'ยกเลิก',
//       },
//       projectCode: {
//         name: 'projectCode',
//         label: 'รหัสโครงการ : ',
//         value: null,
//       },
//       projectName: {
//         name: 'projectName',
//         label: 'ชื่อโครงการ : ',
//         value: null,
//       },
//       firstNameProjectCoordinator: {
//         name: 'firstNameProjectCoordinator',
//         label: 'ชื่อผู้ประสาน : ',
//         value: null,
//       },
//       lastNameProjectCoordinator: {
//         name: 'lastNameProjectCoordinator',
//         label: 'นามสกุลผู้ประสาน : ',
//         value: null,
//       },
//       firstNameResponsinator: {
//         name: 'firstNameResponsinator',
//         label: 'ชื่อ: ',
//         value: null,
//       },
//       lastNameResponsinator: {
//         name: 'lastNameResponsinator',
//         label: 'นามสกุล: ',
//         value: null,
//       },
//       responsinatorIdCard: {
//         name: 'responsinatorIdCard',
//         label: 'เลขที่บัตรประชาชน : ',
//         value: null,
//       },
//       firstNameGrentree: {
//         name: 'firstNameGrentree',
//         label: 'ชื่อ : ',
//         value: null,
//       },
//       lastNameGrentree: {
//         name: 'lastNameGrentree',
//         label: 'นามสกุล : ',
//         value: null,
//       },
//       grentreeIdCard: {
//         name: 'grentreeIdCard',
//         label: 'เลขที่บัตรประชาชน : ',
//         value: null,
//       },
//       organization: {
//         name: 'organization',
//         label: 'องค์กรผู้รับทุน : ',
//         value: null,
//       },
//       contactNo: {
//         name: 'contactNo',
//         label: 'เลขที่สัญญา : ',
//         value: null,
//       },
//       taxNo: {
//         name: 'taxNo',
//         label: 'เลขที่ผู้เสียภาษี : ',
//         value: null,
//       },
//       projectStatus: {
//         label: 'สถานะโครงการ :',
//         name: 'projectStatus',
//         value: '',
//         disabled: false,
//         options: [
//           {
//             label: 'ลงทะเบียน',
//             value: '1',
//           },
//           {
//             label: 'กลั่นกรอง',
//             value: '2',
//           },
//           {
//             label: 'อนุมัติ',
//             value: '3',
//           },
//           {
//             label: 'ดำเนินการ',
//             value: '4',
//           },
//           {
//             label: 'ยกเลิกโครงการ',
//             value: '5',
//           },
//           {
//             label: 'สละสิทธิ์โครงการ',
//             value: '7',
//           },
//           {
//             label: 'ปิดโครงการ',
//             value: '8',
//           },
//           {
//             label: 'ยุติโครงการ',
//             value: '9',
//           },
//         ],
//       },
//       projectDepartment: {
//         label: 'สำนัก : ',
//         name: 'projectDepartment',
//         value: '',
//         disabled: true,
//         options: [
//           {
//             label: 'ฝ่ายอำนวยการ',
//             value: '00',
//           },
//           {
//             label: 'สำนัก 1',
//             value: '01',
//           },
//           {
//             label: 'สำนัก 2',
//             value: '02',
//           },
//           {
//             label: 'สำนัก 3',
//             value: '03',
//           },
//           {
//             label: 'สำนัก 4',
//             value: '04',
//           },
//           {
//             label: 'สำนัก 5',
//             value: '05',
//           },
//           {
//             label: 'สำนัก 6',
//             value: '06',
//           },
//           {
//             label: 'สำนัก 7',
//             value: '07',
//           },
//           {
//             label: 'สนย.',
//             value: '08',
//           },
//           {
//             label: 'สภส.',
//             value: '09',
//           },
//           {
//             label: 'ศรร.',
//             value: '10',
//           },
//           {
//             label: 'ฝ่ายบริหารบุคคล',
//             value: '11',
//           },
//           {
//             label: 'ฝ่ายเทคโนโลยีฯ',
//             value: '12',
//           },
//           {
//             label: 'ฝ่ายสื่อสารองค์กร',
//             value: '13',
//           },
//           {
//             label: 'ฝ่ายบัญชีฯ',
//             value: '14',
//           },
//           {
//             label: 'สำนัก 8',
//             value: '15',
//           },
//           {
//             label: 'สำนัก 9',
//             value: '16',
//           },
//           {
//             label: 'ฝ่ายตรวจสอบภายใน',
//             value: '17',
//           },
//           {
//             label: 'กลุ่มงานวิชาการฯ',
//             value: '18',
//           },
//           {
//             label: 'สำนักสื่อสารการตลาดเพื่อสังคม',
//             value: '19',
//           },
//           {
//             label: 'สำนักวิชาการและนวัตกรรม',
//             value: '20',
//           },
//           {
//             label: 'ฝ่ายติดตามประเมินผล',
//             value: '21',
//           },
//           {
//             label: 'ศูนย์สัญญา',
//             value: '22',
//           },
//           {
//             label: 'สำนัก 10',
//             value: '23',
//           },
//           {
//             label: 'สสค.',
//             value: '24',
//           },
//           {
//             label: 'สำนัก 11',
//             value: '25',
//           },
//           {
//             label: 'ThaiHealth Academy',
//             value: '26',
//           },
//           {
//             label: 'SOOK Enterprise',
//             value: '27',
//           },
//           {
//             label: 'สำนักผู้จัดการ',
//             value: '90',
//           },
//         ],
//       },
//       projectStartDate: {
//         name: 'projectStartDate',
//         label: 'วันที่เริ่มต้น : ',
//         value: null,
//       },
//       projectEndDate: {
//         name: 'projectEndDate',
//         label: 'วันที่สิ้นสุด : ',
//         value: null,
//       },
//     },
//   },
// }
